import {
  AlertDialog,
  SubmitDialog,
} from '@roc/ui';
import { observer } from 'mobx-react';
import { usePayoffRequestStore } from '../hooks/usePayoffRequestStore';
import { RequestPayoffForm } from './requestPayoffForm';

export const RequestPayoffDialog = observer(({ }) => {

  const { payoffRequestStore } = usePayoffRequestStore();

  const onRequestPayoff = async () => {
    await payoffRequestStore.onFormSubmitV2();
    await payoffRequestStore.getPayoffsByLoanId(payoffRequestStore.selectedPayoff?.loanId.toString());
    payoffRequestStore.setIsNewPayoffRequestModalOpen(false);
    payoffRequestStore.setIsPayoffRequestedModalOpen(true);
    payoffRequestStore.setSelectedPayoffId(payoffRequestStore.selectedPayoff?.loanPayoffDataId);
  };

  return (
    <>
      <SubmitDialog
        title="Request Payoff"
        subTitle="You are requesting to pay off this loan in full."
        open={payoffRequestStore.isNewPayoffRequestModalOpen}
        body={<RequestPayoffForm />}
        handleClose={() => {
          payoffRequestStore.setIsNewPayoffRequestModalOpen(false);
          payoffRequestStore.reset();
        }}
        handleOk={() => onRequestPayoff()}
        cancelButtonText='Cancel'
        maxWidth={'xs'}
      />
      <AlertDialog
        open={payoffRequestStore.isPayoffRequestedModalOpen}
        title="Thank you"
        body={"We've received your request. A loan specialist has been notified and we will reach out to you within 24 - 48 business hours."}
        okButtonText='Close'
        handleClose={() => {
          payoffRequestStore.setIsPayoffRequestedModalOpen(false);
          payoffRequestStore.reset();
        }}
        maxWidth={'sm'}
      />
    </>
  );
});